import { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { AppRole, canAccess, useRole } from './useRole'

type Props = { allow?: readonly AppRole[]; children: ReactNode }

/**
 * Route guard: renders children only when the current role satisfies `allow`.
 * While the role is loading we render nothing so we never redirect prematurely.
 * Blocks direct-URL access; the sidebar hides the same links via canAccessEntry.
 */
export const RequireRole = ({ allow, children }: Props) => {
  const { role, isLoading } = useRole()

  if (isLoading) return null

  return canAccess(role, allow) ? <>{children}</> : <Navigate to="/" replace />
}
